/* eslint-disable camelcase */
export enum NetworkStatusEnums  {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  IN_REVIEW = 'INSURANCE_IN_NETWORK_REVIEW',
  NOT_COVERED = 'NOT_COVERED'
}

export type NetworStatus = NetworkStatusEnums.IN_NETWORK | NetworkStatusEnums.OUT_OF_NETWORK | NetworkStatusEnums.IN_REVIEW | NetworkStatusEnums.NOT_COVERED;

export interface Deductibles {
  plan_individual_deductible: string; // e.g., "$100"
  amount_applied_to_deductible: string;
  deductible_remaining: string;
}

export interface OutOfPocketMax {
  plan_oop_max: string; // e.g., "$5000"
  amount_applied_to_oop_max: string;
}

export interface InsuranceEligibilityResponse {
  request_id: string;
  status: string;
  payer_code: string;
  payer_name: string;
  provider_first_name: string;
  provider_last_name: string;
  subscriber_first_name: string;
  subscriber_last_name: string;
  subscriber_member_id: string;
  subscriber_dob: string;
  group_name: string;
  group_number: string;
  effective_date: string;
  policy_type: string;
  plan_name: string;
  network_status: NetworStatus;
  deductibles: Deductibles;
  estimated_copay: string;
  estimated_coinsurance: string;
  out_of_pocket_max: OutOfPocketMax;
  message: string;
  verification_date_time: string;
  expiration_date: string;
  service_types: string[];
  user_id: string;
  session_limit: {
    visit_limitation_in_net: string;
    visit_remaining_in_net:  string;
  };
  service_covered_in_net: string;
  client_name: string;
}

type OfficeAddress = {
  color: string;
  officeTitle: string;
  img: string;
  checkMark: string;
  addressInfo1: string;
  addressInfo2: string;
  addressInfo3: string;
  regionName: string;
  coordinates: [number, number];
  locationInfo: string;
  facilityId: number;
};

export interface Appointment {
  id: string;
  therapist_id: string;
  therapist_name: string;
  therapist_email: string;
  client_id: string;
  client_name: string;
  client_email: string;
  meeting_time: string;
  user_status_updated_at: string;
  user_time_zone: string;
  user_time_zone_key: string;
  service_type: string;
  service_type_key: string;
  meeting_type:   string;
  office_address: string | OfficeAddress;
  therapist_profile_pic_url: string;
  meeting_status: string;
  metadata: Record<string, unknown>;
  therapist_pronoun: string;
  checksum: string;
}
